import { FEATURE_FLAGS } from '../featureFlagsConstants';
import store from '../store';

export const isFeatureEnabledForPhoenix = (featureName) => {
  const DISABLED_FEATURES_FOR_PHOENIX = [
    FEATURE_FLAGS.CANNED_RESPONSES,
    FEATURE_FLAGS.SMS,
    FEATURE_FLAGS.MACROS,
  ];

  const isPhoenix = store.getters['accounts/isPhoenix'];
  return isPhoenix
    ? !DISABLED_FEATURES_FOR_PHOENIX.includes(featureName)
    : true;
};

export const getDisabledRoutesForPhoenixAccount = (isSuperAdmin) => {
  const DISABLED_FOR_PHOENIX_ADMINS = [
    'csat_reports',
    'settings_sms_index',
    'macros_wrapper',
    'macros_new',
    'macros_edit',
    'canned_list',
    'settings_credentials',
    'settings_credentials_list',
    'settings_credentials_new',
    'settings_credentials_edit',
    'settings_credentials_authorizing',
    'ongoing_campaigns',
    'conversation_unattended',
    'bot_reports',
  ];

  const DISABLED_FOR_PHOENIX_USERS = [
    ...DISABLED_FOR_PHOENIX_ADMINS,
    'settings_integrations_dashboard_apps',
    'settings_integrations_integration',
    'settings_integrations_slack',
    'settings_integrations_webhook',
    'settings_integrations',
  ];

  return isSuperAdmin
    ? DISABLED_FOR_PHOENIX_ADMINS
    : DISABLED_FOR_PHOENIX_USERS;
};
